<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="3">
          <AutocompleteGrade :defaultGrade="defaultGrade" />
        </v-col>
        <v-col cols="3">
          <AutocompleteClass :defaultClass="defaultClass" />
        </v-col>
        <v-col cols="3">
          <AutocompleteStudent :defaultStudent="defaultStudent" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'
import { BusStudent } from '@/plugins/api'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade.vue'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'

export default {
  components: {
    AutocompleteStudent,
    AutocompleteGrade,
    AutocompleteClass
  },
  data: () => ({
    bus: null,
    selectedStudent: {},
    selectedGrade: {},
    selectedClass: {},
    defaultStudent: [],
    defaultGrade: [],
    defaultClass: []
  }),
  async created() {
    const data = await this.findByTeacher()
    const grades = []
    const classes = []
    const students = []
    data.forEach(item => {
      grades.push(item.student.grade)
      classes.push(item.student.currentClass)
      students.push(item.student)
    })

    this.defaultStudent = students
    this.defaultGrade = grades
    this.defaultClass = classes
  },
  methods: {
    ...mapActions({
      filterBusStudents: 'BusStudents/filterBusStudents',
      findByTeacher: 'BusStudents/findByTeacher'
    }),

    async onFilterChanged() {
      if (this.$auth.role.type === 'teacher') {
        const data = await BusStudent.findByTeacher()
        return
      }
      this.filterBusStudents({
        'student.id': get(this.selectedStudent, 'id', ''),
        'student.grade': get(this.selectedGrade, 'id', ''),
        'student.currentClass': get(this.selectedClass, 'id', '')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
